import { memo } from 'react';
import SkeletonBox from 'conversations-skeleton-state/components/SkeletonBox';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
function TimelineCallMetadataSkeleton() {
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(SkeletonBox, {
      height: 14,
      width: 228,
      className: "m-bottom-4"
    }), /*#__PURE__*/_jsx(SkeletonBox, {
      height: 14,
      width: "100%",
      className: "m-bottom-2"
    }), /*#__PURE__*/_jsx(SkeletonBox, {
      height: 14,
      width: "80%",
      className: "m-bottom-2"
    })]
  });
}
export default /*#__PURE__*/memo(TimelineCallMetadataSkeleton);